import { axiosApi } from '../axios';

export default {
  authenticate(userCredentials) {
    return axiosApi.post('/sessions', userCredentials);
  },
  getProfile(role) {
    return axiosApi.get('/profile', { params: { source: role } });
  },

  password: {
    check(token) {
      return axiosApi.get(`/password_recovery/${token}/check`);
    },
    recover(email) {
      return axiosApi.post('/password_recovery', email);
    },
    update(token, passwordData) {
      return axiosApi.patch(`/password_recovery/${token}`, passwordData);
    },
  },
};
